const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x36_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D24441"
    },
    d: "M480.759,133.469H275.417c-6.339-1.029-12.85-1.541-19.446-1.541 c-68.533,0-124.045,55.512-124.045,124.045c0,25.784,7.796,49.685,21.246,69.56L10.537,182.896C42.062,77.1,139.978,0,255.971,0 c52.085,0,100.486,15.592,140.921,42.319c28.869,19.103,53.627,43.776,72.645,72.645 C473.563,120.96,477.246,127.129,480.759,133.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CB566"
    },
    d: "M325.532,358.771L182.897,501.405c-20.217-5.996-39.406-14.477-57.225-25.102 c-37.094-21.929-68.105-52.941-90.035-90.033C12.935,348.063,0,303.601,0,255.972c0-25.359,3.684-49.858,10.537-73.076 l142.634,142.636c22.273,32.896,60.052,54.568,102.799,54.568C281.756,380.1,305.657,372.219,325.532,358.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5CB44"
    },
    d: "M275.395,133.442c59.299,9.325,104.657,60.639,104.657,122.557 c0,42.759-21.63,80.462-54.543,102.775L182.888,501.396c23.16,6.887,47.686,10.603,73.083,10.603c141.385,0,256-114.615,256-256 c0-44.4-11.309-86.158-31.195-122.557H275.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M275.417,133.469c-6.339-1.029-12.85-1.541-19.446-1.541c-68.533,0-124.045,55.512-124.045,124.045 c0,25.784,7.796,49.685,21.246,69.56c22.273,32.896,60.052,54.568,102.799,54.568c25.785,0,49.686-7.881,69.561-21.329 c32.896-22.274,54.484-60.054,54.484-102.799C380.015,194.119,334.697,142.805,275.417,133.469z M255.971,356.542 c-55.426,0-100.573-45.058-100.573-100.57c0-55.428,45.146-100.574,100.573-100.574c55.426,0,100.572,45.146,100.572,100.574 C356.543,311.483,311.396,356.542,255.971,356.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5991CD"
    },
    d: "M155.399,256.001c0,55.454,45.117,100.571,100.571,100.571s100.571-45.117,100.571-100.571 S311.424,155.43,255.97,155.43S155.399,200.547,155.399,256.001z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M255.971,155.398c-55.426,0-100.573,45.146-100.573,100.574c0,0,0.001,0.012,0.001,0.021 c0.005-55.451,45.12-100.564,100.571-100.564c27.731,0,52.876,11.283,71.087,29.498l0.005-0.004 C308.846,166.694,283.695,155.398,255.971,155.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M380.015,255.972c0,27.352-8.871,52.646-23.856,73.17c15.004-20.513,23.893-45.78,23.893-73.143 c0-34.26-13.929-65.235-36.383-87.684l-0.019,0.019C366.094,190.781,380.015,221.743,380.015,255.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M356.541,256.001c0,3.459-0.177,6.879-0.519,10.248c0.344-3.38,0.521-6.808,0.521-10.277 c0-27.704-11.278-52.837-29.48-71.049l-0.005,0.004C345.265,203.137,356.541,228.279,356.541,256.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.06,
      fill: "#040000"
    },
    d: "M480.744,133.441c-3.509-6.329-7.187-12.49-11.207-18.478 c-9.496-14.414-20.425-27.783-32.581-39.934l-93.286,93.285c22.453,22.45,36.383,53.424,36.383,87.684 c0,27.363-8.889,52.63-23.893,73.143c14.985-20.523,23.856-45.818,23.856-73.17c0-34.229-13.921-65.191-36.364-87.639 l-16.588,16.59c18.202,18.212,29.48,43.345,29.48,71.049c0,3.47-0.177,6.898-0.521,10.277c0.342-3.369,0.519-6.789,0.519-10.248 c0-27.722-11.277-52.864-29.484-71.074L74.991,436.994c15.125,15.121,32.144,28.35,50.681,39.309 c17.819,10.625,37.008,19.105,57.225,25.102l0.005-0.004C206.059,508.284,230.579,512,255.971,512 c141.385,0,255.999-114.616,255.999-256.001c0-44.4-11.309-86.158-31.195-122.557H480.744z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.6781a5763fb5df6ffa598e12b5e6def9.svg";
export { ForwardRef as ReactComponent };